<template>
  <div class="boxLocaleOccurrence mb-4">
    <header class="boxLocaleOccurrence_header p-2">
      <h3 class="boxLocaleOccurrence_header_title">
        {{ dados.funeraria.nome }}
      </h3>
    </header>
    <div class="boxLocaleOccurrence_body py-2 px-3">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="d-inline-flex align-items-center">
          <ul class="boxLocaleOccurrence_list d-inline-block mr-5">
            <li class="boxLocaleOccurrence_list_title">
              Mostrar endereço na certidão 
            </li>

            <li class="boxLocaleOccurrence_list_item text-capitalize">
              <strong>{{ this.dados.showEndereco ? "Sim" : "Não" }}</strong>
            </li>
          </ul>

          <ul class="boxLocaleOccurrence_list d-inline-block mr-5">
            <li class="boxLocaleOccurrence_list_title">
              Endereço
            </li>

            <li class="boxLocaleOccurrence_list_item text-capitalize">
              <strong>{{ dados.funeraria.endereco | Endereco }}</strong>
            </li>
          </ul>
        </div>

        <div class="d-inline-block">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BoxFuneraria",
    props: {
      dados: Object,
    },
  }
</script>

<style lang="scss">
  @import '/../../../../../scss/_utilities/_exports';

  .boxLocaleOccurrence {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_error {
      border: solid 2px #8B0000;
    }

    &_header {
      background-color: #01AEC9;
      color: $color-dark;

      &_title {
        font-size: pxToRem(18);
        font-weight: 500;
      }
    }

    &_body {
      &_content {}
    }

    &_list {
      font-size: pxToRem(14);
      list-style: none;
      margin: 0;
      padding: 0;

      &_item {}

      &_title {
        margin-bottom: pxToRem(4);
        text-decoration: underline;
      }
    }
  }
</style>
